// a composable to return the vuex store
import { getCurrentInstance } from '@vue/composition-api';

export default function useStore() {
    const vm = getCurrentInstance();
    if (!vm) 
        throw new Error('must be called in setup');
    return vm.proxy.$store;
}
